// Background of a sponsor's logo plate on the homepage band (SponsorBand) and its admin preview
// (SponsorSettings). White suits most artwork; a white / light logo disappears on it, so the
// admin can switch that one sponsor to gray or dark. Stored per sponsor as `plateBg`.
export const PLATE_BGS = {
    light: { label: 'ขาว', bg: '#FFFFFF', border: '#E9EEF6', text: null },
    gray: { label: 'เทา', bg: '#E2E8F0', border: '#CBD5E1', text: null },
    dark: { label: 'เข้ม', bg: '#0F172A', border: '#1E293B', text: '#F1F5F9' },
};

export const plateBgKey = (v) => (PLATE_BGS[v] ? v : 'light');

// Inline style for a plate; null for the default white plate (its look stays in CSS).
export function plateStyle(v) {
    const key = plateBgKey(v);
    if (key === 'light') return null;
    const p = PLATE_BGS[key];
    return { background: p.bg, borderColor: p.border };
}

// Sponsor-name colour on a dark plate (the tier classes are gray-on-white).
export function plateTextStyle(v) {
    const t = PLATE_BGS[plateBgKey(v)].text;
    return t ? { color: t } : null;
}
